export default __webpack_public_path__ + "static/media/senders.bb9d375f.svg";